import Documents from './documents.webp';
import AccountShowCase from './wow-bg-1.webp';
import ScreenName from './screen-name.png';
import SportTeamsBannerMob from './partnership-banner-mob.webp';
import SportTeamsBanner from './partnership-banner.webp';
import rgCheck from './rg-check.webp';

export default {
  Documents,
  AccountShowCase,
  ScreenName,
  SportTeamsBannerMob,
  SportTeamsBanner,
  rgCheck,
};
